import { useFeedback } from '@/components/notifications/Feedback/useFeedback';
import { HIDDEN_BALANCE_SHEET_CATEGORY_TYPES } from '@/modules/assetCategories/assetCategories.constants';
import { getNodes } from '@/utils/graphqlUtils';

import { useAssetCategoriesQuery } from '../graphql/StructuredAssetsSubform.generated';

export function useAssetCategoryOptions() {
  const { createErrorFeedback } = useFeedback();
  const { data, ...queryProps } = useAssetCategoriesQuery({
    fetchPolicy: 'cache-and-network',
    onError: createErrorFeedback('Failed to fetch asset categories'),
  });

  const options = getNodes(data?.assetClasses)
    .filter(
      (ac) =>
        !ac.balanceSheetCategory?.type ||
        !HIDDEN_BALANCE_SHEET_CATEGORY_TYPES.has(ac.balanceSheetCategory.type)
    )
    .sort((a, b) => a.displayName.localeCompare(b.displayName))
    .map((ac) => ({
      display: ac.displayName,
      value: ac.id,
    }));

  return { options, data, ...queryProps };
}
